import cdnDependencies from '@config/cdn-dependencies.json';
import { isOffline } from '@/utils/offline';
const OFFLINE_RESOURCE_PATH = '/xystatic/extensions/wuji-static-resource';
export const CDN_MODULES = Object.keys(cdnDependencies);
export function getCdnModulePath(moduleName) {
    const config = cdnDependencies[moduleName];
    if (!config)
        throw new Error(`Unknown CDN module: ${moduleName}`);
    if (!isOffline())
        return config.onlinePath;
    const pathPrefix = window.GLOBAL_INFO?.pathPrefix?.replace(/\/+$/, '') || '';
    const offlineFile = config.offlineFile.replace(/\.js$/, '');
    return `${pathPrefix}${OFFLINE_RESOURCE_PATH}/${offlineFile}`;
}
